module.exports = __webpack_public_path__ + "img/jenius.b1077956.svg";